import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { MuiInputDirective } from '../../../module/legacy/forms/mui-input.directive';
import { NAME_PREFIXES } from '../../../ui/form/abstract-address-fieldset.component';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
import { AbstractEditFormComponent } from '../form/abstract-edit-form.component';
import { AccountEditFormLayoutComponent } from '../form/layout/account-edit-form-layout.component';
@Component({
    selector: 'account-edit-personal',
    templateUrl: './account-edit-personal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, FormsModule, AccountEditFormLayoutComponent, MuiInputDirective, InputWrapComponent, CommonModule, InputWrapBodyDirective]
})
export class AccountEditPersonalComponent extends AbstractEditFormComponent {
    readonly prefixes = NAME_PREFIXES;
}
